import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class DictionaryCountryResponse {
  @jsonMember(String)
  public readonly id!: string;

  @jsonMember(String)
  public readonly isoCode!: string;

  @jsonMember(String)
  public readonly label!: string;
}
